import {handleValidationChange} from '../CommonValidation';

export const validateDiscount = (data, setIsError) => {

    var isValid = true;
    var isValidName = true;
    var isValidPercentage = true;
    var isValidAmount = true;
    var isValidID = true;

    if(data.id === "") {
        handleValidationChange("id", true, setIsError);
        isValidID = false;
    } else {
        handleValidationChange("id", false, setIsError);
        isValidID = true;
    }

    if(data.name === "") {
        handleValidationChange("name", true, setIsError);
        isValidName = false;
    } else {
        handleValidationChange("name", false, setIsError);
        isValidName = true;
    }
    if(data.open_discount_amount === "1" || data.open_discount_rate === "1"){
        if(data.is_percentage === "1") {
            if(data.percentage === "") {
            handleValidationChange("percentage", false, setIsError);
            isValidPercentage = true;
            } else {
                handleValidationChange("percentage", true, setIsError);
                isValidPercentage = false;
            }
        } else {
            if(data.amount === "") {
                handleValidationChange("amount", false, setIsError);
                isValidPercentage = true;
            } else {
                handleValidationChange("amount", true, setIsError);
                isValidPercentage = false;
            }
        }
    }else{
        if(data.is_percentage === "1") {
            if(data.percentage === "") {
            handleValidationChange("percentage", true, setIsError);
            isValidPercentage = false;
            } else {
                handleValidationChange("percentage", false, setIsError);
                isValidPercentage = true;
            }
        } else {
            if(data.amount === "") {
                handleValidationChange("amount", true, setIsError);
                isValidPercentage = false;
            } else {
                handleValidationChange("amount", false, setIsError);
                isValidPercentage = true;
            }
        }
    }

    isValid = isValidName && isValidPercentage

    return isValid
  
}   